import { coreApi } from '@cp/shared/api/core';
import { CoreApiMetaTags, coreApiMetaTagTypes } from '../tags';
import { ClientWebRoutesMetaByPageRequest } from './request';
import { ClientWebRoutesMetaByPageResponse } from './response';

export const coreRouterClientWebRoutesMetaByPageApi = coreApi.enhanceEndpoints({ addTagTypes: coreApiMetaTagTypes }).injectEndpoints({
  endpoints: (builder) => ({
    getClientWebRoutesMetaByPage: builder.query<ClientWebRoutesMetaByPageResponse, ClientWebRoutesMetaByPageRequest>({
      query: ({ pageId, parameters }) => ({
        url: `meta/client-web-pages/${pageId}/routes-meta`,
        params: {
          parameters,
        },
      }),
      providesTags: (result, error, { pageId }) => [{ type: CoreApiMetaTags.ClientWebRouteMeta, id: `page-${pageId}` }],
    }),
  }),

  overrideExisting: false,
});
